
angular.module('taric.model.measure', ['common.helper', 'ngResource'])
    .factory('QueryMeasure', function ($resource, CONSTANTS) {
        return $resource(CONSTANTS.host + CONSTANTS.ws_context + '/secure/ccrm/measures', {}, {
            querySecure: {
                method: 'GET',
                isArray: false,
                url: CONSTANTS.host + CONSTANTS.ws_context + '/secure/ccrm/measures'
            },
            getMeasureExtendedInfoForMeasureType: {
                method: 'GET',
                isArray: false,
                url: CONSTANTS.host + CONSTANTS.ws_context + '/ref/meae/measures/:id'
            },
            getMeasureExtendedInfoForMeasureTypeSecure: {
                method: 'GET',
                isArray: false,
                url: CONSTANTS.host + CONSTANTS.ws_context + '/secure/ref/meae/measures/:id'
            },
            getMeasureExtendedInfoForMeasureConditions: {
                method: 'GET',
                isArray: false,
                url: CONSTANTS.host + CONSTANTS.ws_context + '/ref/meae/conditions/:id'
            },
            queryMeasuresForNomenclature: {
                method: 'GET',
                isArray: false,
                url: CONSTANTS.host + CONSTANTS.ws_context + '/mcc/measures'
            },
            queryMeasuresForNomenclatureSecure: {
                method: 'GET',
                isArray: false,
                url: CONSTANTS.host + CONSTANTS.ws_context + '/secure/mcc/measures'
            },
            queryMeasureConditionsForNomenclature: {
                method: 'GET',
                isArray: false,
                url: CONSTANTS.host + CONSTANTS.ws_context + '/mcc/measures/conditions'
            }
        });
    }).service('MeasureByCCSearchModel', function ($q, QueryMeasure, CommonHelper, CONSTANTS, AuthorizeModel) {
    var model = this;

    var searchCriteria = {},
        searchMeasureResult = null;

    model.getSearchMeasureResult = function () {
        return searchMeasureResult;
    };
    model.resetSearchResult = function () {
        searchMeasureResult = null;
    };
    model.resetSearchCriteria = function () {
        searchCriteria = {};
        searchCriteria.commodityCode = '';
        searchCriteria.simulationDate = new Date();
        searchCriteria.ascending = true;
        searchCriteria.direction = "I";
        searchCriteria.country = null;

        if (CONSTANTS.releaseManagement) {
            model.includeUnreleased = AuthorizeModel.loggedIn && AuthorizeModel.isIncludedUnreleasedDataViewer();
        } else {
            model.includeUnreleased = false;
        }
        model.loggedIn = AuthorizeModel.loggedIn;
    };

    model.getSearchCriteria = function () {
        return searchCriteria;
    };

    model.reset = function () {

        //Set the default search criteria when the model is initialized
        model.resetSearchCriteria();
        model.resetSearchResult();
    };

    model.reset();

    model.searchMeasure = function (pageNumber) {
        var deferred = $q.defer();

        var options = {
            simulationdate: CommonHelper.getRestDateString(searchCriteria.simulationDate),
            commoditycode: CommonHelper.removeSpaceCharacters(searchCriteria.commodityCode),
            tradedirection: searchCriteria.direction,
            measuretype: searchCriteria.measureType,
            country: searchCriteria.country,
            sortorder: searchCriteria.ascending ? 'A' : 'D',
            sortcolumn: searchCriteria.sortCol
        };

        if (pageNumber) {
            options.offset = CommonHelper.getOffset(pageNumber);
            options.count = CONSTANTS.rowsPerPage;
        }

        // ITESUP-164: Query measures by commodity codes will only be available for logged in user.
        options.filterHiddenMeasureTypes = false;
        if (CONSTANTS.releaseManagement) {
            options.includeUnreleased = model.includeUnreleased;
        }
        var resultSecure = QueryMeasure.querySecure(options, function () {
            var returnedResult = {};
            returnedResult.totalItems = resultSecure.count;
            returnedResult.measures = resultSecure.items;
            returnedResult.currentPage = pageNumber;

            // ACSMNT-3673 Only display EU hint for Sweden.
            if (CONSTANTS.installationCountry.toUpperCase() === 'SE') {
                returnedResult.isSelectedCountryAnEUMember = resultSecure.isSelectedCountryAnEUMember;
            }

            angular.forEach(returnedResult.measures, function (measure) {
                if (measure.excludedCountryIds.length > 0) {
                    measure.excludedCountryIds = measure.excludedCountryIds.join(" ");
                } else {
                    measure.excludedCountryIds = '';
                }
                var orderNumber = measure.orderNumber;
                if (orderNumber) {
                    // Use regexp to compare with orderNumber
                    var regexp = new RegExp(CONSTANTS.licenseQuotaPattern);
                    measure.licenseQuota = regexp.test(orderNumber);
                } else {
                    measure.licenseQuota = false;
                }
            });

            if (pageNumber){
                searchMeasureResult = returnedResult;
            }

            deferred.resolve(returnedResult);
        }, function (error) {
            deferred.reject(error);
        });
        return deferred.promise;
    };
}).service('MeasurePopupModel', function ($q, QueryMeasure, CommonHelper, AuthorizeModel) {
    var model = this;
    model.getMeasureExtendedInfoForMeasureType = function (measureSid, preferenceCodesForMeasureOnly, commodityCode, country, direction, selectedPreferenceCode, additionalCodes, simulationDate, version, unreleased) {
        var deferred = $q.defer();
        if (AuthorizeModel.loggedIn) {
            QueryMeasure.getMeasureExtendedInfoForMeasureTypeSecure({
                id: measureSid,
                preferenceCodesForMeasureOnly: preferenceCodesForMeasureOnly,
                commodityCode: CommonHelper.removeSpaceCharacters(commodityCode),
                country: country,
                tradeDirection: direction,
                selectedPreferenceCode: selectedPreferenceCode,
                additionalCodes: additionalCodes,
                simulationDate: CommonHelper.getRestDateString(simulationDate),
                filterHiddenMeasureTypes: false,
                version: version,
                unreleased: unreleased
            }, function (measureExtendedInfoSecure) {
                deferred.resolve(measureExtendedInfoSecure);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        } else {
            QueryMeasure.getMeasureExtendedInfoForMeasureType({
                id: measureSid,
                preferenceCodesForMeasureOnly: preferenceCodesForMeasureOnly,
                commodityCode: CommonHelper.removeSpaceCharacters(commodityCode),
                country: country,
                tradeDirection: direction,
                selectedPreferenceCode: selectedPreferenceCode,
                additionalCodes: additionalCodes,
                simulationDate: CommonHelper.getRestDateString(simulationDate),
                filterHiddenMeasureTypes: true,
                version: version
            }, function (measureExtendedInfoSecure) {
                deferred.resolve(measureExtendedInfoSecure);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }
    };

}).service('ConditionPopupModel', function ($q, QueryMeasure, CommonHelper, $translate) {
    var model = this;
    model.getMeasureExtendedInfoForMeasureConditions = function (measureSid, monetaryUnitCode, additionalCodes, simulationDate, direction, unreleased) {
        var deferred = $q.defer();
        QueryMeasure.getMeasureExtendedInfoForMeasureConditions({
            id: measureSid,
            monetaryUnitCode: monetaryUnitCode,
            additionalCodes: additionalCodes,
            simulationDate: CommonHelper.getRestDateString(simulationDate),
            tradeDirection: direction,
            language: CommonHelper.getLanguageCode($translate.use()),
            unreleased: unreleased
        }, function (measureConditionHead) {
            deferred.resolve(measureConditionHead);
        }, function (error) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

}).service('MeasureForNomenclatureSearchModel', function ($q, QueryMeasure, CommonHelper, CONSTANTS, $translate, AuthorizeModel) {
    var model = this;
    var searchCriteria = {},
        searchMeasureResult = null;
    model.getSearchMeasureResult = function () {
        return searchMeasureResult;
    };
    model.resetSearchResult = function () {
        searchMeasureResult = null;
    };
    model.getSearchCriteria = function () {
        return searchCriteria;
    };
    model.resetSearchCriteria = function () {
        //Set the default search criteria when the model is initialized
        searchCriteria = {};
        searchCriteria.commodityCode = '';
        searchCriteria.simulationDate = new Date();
        searchCriteria.ascending = true;
        searchCriteria.direction = "I";
        searchCriteria.currency = CONSTANTS.installationCurrency;
        searchCriteria.additionalCodes = [];
        searchCriteria.queryAdditionalCodes = [];
        searchCriteria.additionalCode = null;
        searchCriteria.country = null;

        if (CONSTANTS.releaseManagement) {
            model.includeUnreleased = AuthorizeModel.loggedIn && AuthorizeModel.isIncludedUnreleasedDataViewer();
        } else {
            model.includeUnreleased = false;
        }
        model.loggedIn = AuthorizeModel.loggedIn;
    };

    model.reset = function () {
        model.resetSearchCriteria();
        model.resetSearchResult();
    };

    model.reset();

    model.queryMeasuresForNomenclature = function (pageNumber) {

        var options = {
            simulationdate: CommonHelper.getRestDateString(searchCriteria.simulationDate),
            commoditycode: CommonHelper.removeSpaceCharacters(searchCriteria.commodityCode),
            tradedirection: searchCriteria.direction,
            measuretype: searchCriteria.measureType,
            country: searchCriteria.country,
            currency: searchCriteria.currency,
            additionalcodes: searchCriteria.queryAdditionalCodes,
            sortorder: searchCriteria.ascending ? 'A' : 'D',
            sortcolumn: searchCriteria.sortCol
        };

        if (pageNumber) {
            options.offset = CommonHelper.getOffset(pageNumber);
            options.count = CONSTANTS.rowsPerPage;
        }

        var deferred = $q.defer();
        if (model.loggedIn) {
            options.filterHiddenMeasureTypes = false;
            if (CONSTANTS.releaseManagement) {
                options.includeUnreleased = model.includeUnreleased;
            }
            var resultSecure = QueryMeasure.queryMeasuresForNomenclatureSecure(options, function () {
                var returnedResult = {};
                returnedResult.totalItems = resultSecure.count;
                returnedResult.measures = resultSecure.items;
                returnedResult.currentPage = pageNumber;
                returnedResult.commodityCodeHead = resultSecure.commodityCodeHead;
                returnedResult.additionalCodes = resultSecure.additionalCodes;
                returnedResult.measureFootnotes = resultSecure.measureFootnotes;
                returnedResult.hasMeursingComponents = resultSecure.hasMeursingComponents;
                returnedResult.hasCountry = !!searchCriteria.country;
                returnedResult.hasConditions = resultSecure.hasConditions;
                if (searchCriteria.direction === 'E' && returnedResult.commodityCodeHead.commodityCode.length === 10) {
                    returnedResult.commodityCodeHead.commodityCode = returnedResult.commodityCodeHead.commodityCode.substr(0, 8);
                }

                // ACSMNT-3673 Only display EU hint for Sweden.
                if (CONSTANTS.installationCountry.toUpperCase() === 'SE') {
                    returnedResult.isSelectedCountryAnEUMember = resultSecure.isSelectedCountryAnEUMember;
                }

                angular.forEach(returnedResult.measures, function (measure) {
                    if (measure.excludedCountryIds.length > 0) {
                        measure.excludedCountryIds = measure.excludedCountryIds.join(" ");
                    } else {
                        measure.excludedCountryIds = '';
                    }
                    var orderNumber = measure.orderNumber;
                    if (orderNumber) {
                        // Use regexp to compare with orderNumber
                        var regexp = new RegExp(CONSTANTS.licenseQuotaPattern);
                        measure.licenseQuota = regexp.test(orderNumber);
                    } else {
                        measure.licenseQuota = false;
                    }
                });

                if (pageNumber) {
                    searchMeasureResult = returnedResult;
                }

                deferred.resolve(returnedResult);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        } else {
            options.filterHiddenMeasureTypes = true;
            var result = QueryMeasure.queryMeasuresForNomenclature(options, function () {
                var returnedResult = {};
                returnedResult.totalItems = result.count;
                returnedResult.measures = result.items;
                returnedResult.currentPage = pageNumber;
                returnedResult.commodityCodeHead = result.commodityCodeHead;
                returnedResult.additionalCodes = result.additionalCodes;
                returnedResult.measureFootnotes = result.measureFootnotes;
                returnedResult.hasMeursingComponents = result.hasMeursingComponents;
                returnedResult.hasCountry = !!searchCriteria.country;
                returnedResult.hasConditions = result.hasConditions;
                if (searchCriteria.direction === 'E' && returnedResult.commodityCodeHead.commodityCode.length === 10) {
                    returnedResult.commodityCodeHead.commodityCode = returnedResult.commodityCodeHead.commodityCode.substr(0, 8);
                }

                // ACSMNT-3673 Only display EU hint for Sweden.
                if (CONSTANTS.installationCountry.toUpperCase() === 'SE') {
                    returnedResult.isSelectedCountryAnEUMember = result.isSelectedCountryAnEUMember;
                }

                angular.forEach(returnedResult.measures, function (measure) {
                    if (measure.excludedCountryIds.length > 0) {
                        measure.excludedCountryIds = measure.excludedCountryIds.join(" ");
                    } else {
                        measure.excludedCountryIds = '';
                    }
                    var orderNumber = measure.orderNumber;
                    if (orderNumber) {
                        // Use regexp to compare with orderNumber
                        var regexp = new RegExp(CONSTANTS.licenseQuotaPattern);
                        measure.licenseQuota = regexp.test(orderNumber);
                    } else {
                        measure.licenseQuota = false;
                    }
                });

                if (pageNumber) {
                    searchMeasureResult = returnedResult;
                }
                deferred.resolve(returnedResult);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

    };

    model.queryMeasureConditionsForNomenclature = function (page) {
        var deferred = $q.defer();
        var options = {
            simulationdate: CommonHelper.getRestDateString(searchCriteria.simulationDate),
            commoditycode: CommonHelper.removeSpaceCharacters(searchCriteria.commodityCode),
            tradedirection: searchCriteria.direction,
            country: searchCriteria.country,
            currency: searchCriteria.currency,
            additionalcodes: searchCriteria.queryAdditionalCodes,
            offset: CommonHelper.getOffset(page),
            count: CONSTANTS.rowsPerPage,
            sortorder: searchCriteria.ascending ? 'A' : 'D',
            sortcolumn: searchCriteria.sortCol,
            language: CommonHelper.getLanguageCode($translate.use())
        };
        if (CONSTANTS.releaseManagement) {
            options.includeUnreleased = model.includeUnreleased;
        }
        var result = QueryMeasure.queryMeasureConditionsForNomenclature(options, function () {
            deferred.resolve(result);
        }, function (error) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

});



// WEBPACK FOOTER //
// ./app/taric/measure/shared/measure-model.js